import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { useMovieStore } from './movieStore';
export const useAuthStore = create()(persist((set) => ({
    // Initial state
    user: null,
    accessToken: null,
    refreshToken: null,
    isAuthenticated: false,
    // Actions
    setAuth: (user, accessToken, refreshToken) => set({
        user,
        accessToken,
        refreshToken,
        isAuthenticated: true,
    }),
    logout: () => {
        useMovieStore.getState().unloadMovie();
        set({
            user: null,
            accessToken: null,
            refreshToken: null,
            isAuthenticated: false,
        });
    },
    updateTokens: (accessToken, refreshToken) => set({
        accessToken,
        refreshToken,
    }),
}), {
    name: 'prototype-auth', // localStorage key
    partialize: (state) => ({
        user: state.user,
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        isAuthenticated: state.isAuthenticated,
    }),
}));
// Selectors
export const selectUserRole = (state) => state.user?.role ?? null;
export const selectIsSystem = (state) => state.user?.role === 'system';
export const selectIsAdmin = (state) => state.user?.role === 'admin' || state.user?.role === 'system';
export const selectIsEditor = (state) => state.user?.role === 'editor' || state.user?.role === 'admin' || state.user?.role === 'system';
export const selectIsViewer = (state) => state.user?.role === 'viewer';
export const selectCanAccessAdmin = (state) => state.user?.role === 'admin' || state.user?.role === 'system';
// Helper: Kullanıcının belirli bir role sahip olup olmadığını kontrol eder
export const hasRole = (user, roles) => {
    if (!user)
        return false;
    return roles.includes(user.role);
};
